<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-22 11:06:53
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_BooleanField.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 15:57:21
-->
<template>
  <v-container fluid class="pa-0 ma-0">
    <v-sheet
      class="text--secondary"
      :class="Number(isRequire) ? ' mrc_text_require ' : ''"
      >{{ label }}</v-sheet
    >
    <v-row class="pt-3">
      <v-col xs="3" sm="2" md="2" lg="2">
        <v-sheet
          class="d-flex flex-row align-center"
          @click="
            () => {
              if (disabled) return;
              booleanTrue = 1;
              booleanFalse = 0;
              $emit('click', true);
            }
          "
        >
          <v-rating
            v-model="booleanTrue"
            size="25"
            readonly
            :disabled="disabled"
            class="mx-2"
            :background-color="disabled ? 'grey' : 'primary'"
            :color="disabled ? 'grey' : 'primary'"
            empty-icon="radio_button_unchecked"
            full-icon="radio_button_checked"
            :length="1"
            dense
          />
          <span :class="disabled ? 'text--secondary' : 'text--primary'">{{
            $t(trueLabel)
          }}</span>
        </v-sheet>
      </v-col>
      <v-col xs="3" sm="2" md="2" lg="2">
        <v-sheet
          class="d-flex flex-row align-center"
          @click="
            () => {
              if (disabled) return;
              booleanTrue = 0;
              booleanFalse = 1;
              $emit('click', false);
            }
          "
        >
          <v-rating
            size="25"
            class="mx-2"
            v-model="booleanFalse"
            :background-color="disabled ? 'grey' : 'primary'"
            readonly
            :disabled="disabled"
            :color="disabled ? 'grey' : 'primary'"
            :length="1"
            dense
            empty-icon="radio_button_unchecked"
            full-icon="radio_button_checked"
          />
          <span :class="disabled ? 'text--secondary' : 'text--primary'">{{
            $t(falseLabel)
          }}</span>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "BooleanRadioField",
  model: {
    prop: "value",
    event: "click",
  },
  props: {
    label: { default: "", type: [Object, Array, String] },
    value: { default: "", type: [String, Number, Array, Object, Boolean] },
    disabled: { default: false, type: [Number, Boolean] },
    trueLabel: {
      default: "label_essweb_system_label_trueLabel",
      type: [Object, Array, String],
    },
    isRequire: { default: false, type: [Number, Boolean] },
    falseLabel: {
      default: "label_essweb_system_label_falseLabel",
      type: [Object, Array, String],
    },
  },
  computed: {
    curValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("click", val);
        return val;
      },
    },
  },
  created() {
    if (this.value) {
      this.booleanFalse = 0;
      this.booleanTrue = 1;
    } else {
      this.booleanFalse = 1;
      this.booleanTrue = 0;
    }
  },
  watch: {
    value(val) {
      this.curValue = val;
    },
    curValue(val) {
      if (val) {
        this.booleanFalse = 0;
        this.booleanTrue = 1;
      } else {
        this.booleanFalse = 1;
        this.booleanTrue = 0;
      }
    },
  },
  data() {
    return {
      booleanFalse: 1,
      booleanTrue: 0,
    };
  },
};
</script>